import request from '../../src/state/modules/axios'

export function getSchoolJobVacancyCreds(){
    return request({
        url: '/api/school-job-vacancy-creds',
        method: 'get',
    })
}

export function getSchoolFJobVacancyCreds(){
    return request({
        url: '/api/school-job-fvacancy-creds',
        method: 'get',
    })
}

export function showSchoolJobCreds(id){
    return request({
        url:`/api/school-job-vacancy-creds/${id}`,
        method: 'get'
    })
}

export function addSchoolJobVacancyCreds(data){
    return request({
        url: '/api/school-job-vacancy-creds',
        method: 'post',
        data,
    })
}

export function editSchoolJobVacancyCreds(data){
    return request({
        url: `/api/school-job-vacancy-creds/${data.id}`,
        method: 'put',
        data,
    })
}

export function deleteSchoolJobVacancyCreds(data){
    return request({
        url: `/api/school-job-vacancy-creds/${data.id}`,
        method: 'delete'
    })
}

export function checkApplicationMobile(params) {
    return request({
        url:'/api/check-vacancy-mobile',
        method: 'get',
        params,
    })
}

export function sendVacancySmsCode(data) {
    return request({
        url:'/api/send-vacancy-sms-code',
        method: 'post',
        data,
    })
}
